import React from 'react';
import ShortcutsSettingsSection from './settings/ShortcutsSettingsSection';
import TagsSettingsSection from './settings/TagsSettingsSection';
import BusinessHoursSettingsSection from './settings/BusinessHoursSettingsSection';
import AutomaticMessagesSettingsSection from './settings/AutomaticMessagesSettingsSection';
import GlobalMessagesSettingsSection from './settings/GlobalMessagesSettingsSection';
import useToken from 'hooks/useToken';

const SettingsView = ({ activeSubTab = 'atajos' }) => {
  const { idCatTipoUsuario } = useToken();
  const isAdmin = Number(idCatTipoUsuario) === 1;

  return (
    <div>
      {activeSubTab === 'atajos' && <ShortcutsSettingsSection />}
      {activeSubTab === 'horarios' && <BusinessHoursSettingsSection />}
      {activeSubTab === 'incidencias' && <TagsSettingsSection />}
      {activeSubTab === 'mensajes' && <AutomaticMessagesSettingsSection />}
      {activeSubTab === 'globales' && isAdmin && <GlobalMessagesSettingsSection />}
    </div>
  );
};

export default SettingsView;


